<label [for]="inputId" class="block text-sm font-medium text-gray-700">  {{ label }} </label>
<div class="mt-1">

  <ng-content></ng-content>

</div>
<ng-content select="p"></ng-content>
